import Web3 from 'web3';
import { LocalAddress, CryptoUtils } from 'loom-js';
import config from '../config';

const sampleKey = 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa==';

const web3Singletone = (function() {
  let web3;
  let currentPrivateKey;
  let publicAddress;
  function createInstance(privateKeyBase64) {
    const privateKey = CryptoUtils.B64ToUint8Array(privateKeyBase64);
    const publicKey = CryptoUtils.publicKeyFromPrivateKey(privateKey);
    currentPrivateKey = privateKeyBase64;
    publicAddress = LocalAddress.fromPublicKey(publicKey).toString();
    web3 = new Web3(config.sidechain.provider(privateKey));
  }
  return {
    getWeb3: function(privateKeyBase64) {
      if (privateKeyBase64 === null || privateKeyBase64 === undefined) {
        privateKeyBase64 = sampleKey;
      }
      if (currentPrivateKey !== privateKeyBase64) {
        createInstance(privateKeyBase64);
      }
      return web3;
    },
    getPublicAddress: function(privateKeyBase64) {
      if (privateKeyBase64 === null || privateKeyBase64 === undefined) {
        privateKeyBase64 = sampleKey;
      }
      if (currentPrivateKey !== privateKeyBase64) {
        createInstance(privateKeyBase64);
      }
      return publicAddress;
    },
    getNetwork: function() {
      return config.sidechain.networkId;
    },
    resetWeb3: function() {
      if (currentPrivateKey !== sampleKey) {
        createInstance(sampleKey);
      }
    }
  };
})();

export default web3Singletone;
